<template>
  <b-overlay :show="processing" rounded="sm" class="overlay-display">
    <template #overlay>
      <div class="text-center">
        <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
        <p id="cancel-label">{{ processingMessage }}</p>
      </div>
    </template>
    <ErrorAlert
      :show="alert.error"
      :message="alert.message"
      @hide-alert="hideError"
    />
    <SuccessAlert
      :show="alert.success"
      :message="alert.message"
      @hide-alert="hideSuccess"
    />

    <!-- Week change notification modal -->
    <b-modal
      id="week-change-modal"
      title="⚠️ Inventory Week Changed"
      ok-only
      ok-title="Got it"
      ok-variant="warning"
      header-bg-variant="warning"
      header-text-variant="dark"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <p class="mb-1">
        <strong>Inventory has been adjusted from week {{ weekChangeInfo.oldWeek }} to week {{ weekChangeInfo.newWeek }}.</strong>
      </p>
      <p class="mb-0 text-danger">
        <strong>Do NOT manually adjust inventory for the week ({{ weekChangeInfo.oldWeek }}) and week {{ weekChangeInfo.newWeek }}.</strong>
      </p>
    </b-modal>

    <div class="container-fluid p-0" id="order-reports">
      <div class="row">
        <div class="col-auto">
          <h3><strong>Order Adjustments</strong></h3>
        </div>
      </div>

      <div class="row mt-3 mb-0 form">
        <div class="col-md-12 col-xl-12 col-12">
          <div class="form-card">
            <b-form id="order-report-form">
              <b-tabs
                v-model="activeTab"
                active-nav-item-class="font-weight-bold text-white bg-primary"
                nav-class="font-weight-bold text-dark bg-secondary"
                @activate-tab="onActivateTab"
                justified
              >
                <b-tab title="Single order" active>
                  <div class="row mt-3">
                    <div class="col-sm">
                      <b-form-group>
                        <b-form-input
                          id="input-1"
                          v-model="order.orderId"
                          type="text"
                          @keyup.enter="query1"
                          placeholder="Please input Order Name"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm">
                      <b-button
                        type="button"
                        variant="primary"
                        class="submit-button"
                        @click="query1"
                      >
                        Query
                      </b-button>
                      &nbsp;<label class="mt-1 text-danger"
                        ><b>{{ alertMessage }}</b></label
                      >
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Multiple orders">
                  <div class="row mt-3">
                    <div class="col-sm">
                      <b-form-textarea
                        id="textarea"
                        v-model="orderIds"
                        placeholder="Please input multiple order names... (Format: #11111,#22222,#33333)"
                        rows="3"
                        max-rows="100"
                      ></b-form-textarea>
                    </div>
                    <div class="col-sm">
                      <b-button
                        type="button"
                        variant="primary"
                        class="submit-button"
                        @click="query2"
                      >
                        Query
                      </b-button>
                      &nbsp;<label class="mt-1 text-danger"
                        ><b>{{ alertMessage }}</b></label
                      >
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Wedding orders">
                  <div class="row mt-3">
                    <div class="col-sm">
                      <b-form-group>
                        <b-form-input
                          id="input-1"
                          v-model="recordID"
                          type="text"
                          placeholder="please input record ID"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm">
                      <b-button
                        type="button"
                        variant="primary"
                        class="submit-button"
                        @click="query3"
                      >
                        Query
                      </b-button>
                      &nbsp;<label class="mt-1 text-danger"
                        ><b>{{ alertMessage }}</b></label
                      >
                    </div>
                  </div>
                </b-tab>
              </b-tabs>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Province: ({{ order.province }})</label
                    >
                    <b-form-select
                      v-model="form.province"
                      :options="provincesOpt"
                      @change="selectProvince"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >City: ({{ order.city }})</label
                    >
                    <v-select
                      :options="citiesOpt"
                      v-model="form.city"
                      @input="selectCity"
                      class="input-height mt-1"
                    ></v-select>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Region: ({{ order.region }})</label
                    >
                    <b-form-input
                      v-model="form.region"
                      type="text"
                      readonly
                      placeholder="Region"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Delivery date: ({{ order.deliveryDate }})</label
                    >
                    <b-form-datepicker
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                      }"
                      v-model="form.deliveryDateNew"
                      :date-disabled-fn="dateDisabled"
                      @input="queryProducts"
                      class="mb-2"
                      required
                    ></b-form-datepicker>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Postal Code: ({{ order.postalCode }})</label
                    >
                    <b-form-input
                      v-model="form.postalCode"
                      @blur="queryDeliveryWindow"
                      maxlength="7"
                      type="text"
                      placeholder="Please input Postal Code"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Lang: ({{ order.lang }})</label
                    >
                    <b-form-select
                      v-model="form.lang"
                      :options="langOpt"
                      @change="queryDeliveryWindow"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Consent: ({{ order.consent }})</label
                    >
                    <b-form-select
                      v-model="form.consent"
                      :options="consentOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Contact Name: ({{ order.cname }})</label
                    >
                    <b-form-input
                      v-model="form.cname"
                      type="text"
                      placeholder="please input Contact Name"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Phone Number: ({{ order.phone }})</label
                    >
                    <b-form-input
                      v-model="form.phone"
                      type="text"
                      placeholder="please input Phone Number"
                      class="input-height mt-1"
                      @input="formatPhoneNumber"
                      maxlength="14"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >First Name: ({{ order.firstName }})</label
                    >
                    <b-form-input
                      v-model="form.firstName"
                      type="text"
                      placeholder="please input First Name"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Last Name: ({{ order.lastName }})</label
                    >
                    <b-form-input
                      v-model="form.lastName"
                      type="text"
                      placeholder="please input Last Name"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Address: ({{ order.address }})</label
                    >
                    <b-form-input
                      id="address-autocomplete-pull"
                      ref="addressInput"
                      v-model="form.address"
                      type="text"
                      placeholder="please input Address"
                      class="input-height mt-1"
                      @input="extractPostalCodeFromAddress"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Buzzer Code: ({{ order.buzzerCode }})</label
                    >
                    <b-form-input
                      v-model="form.buzzerCode"
                      type="text"
                      placeholder="please input Buzzer Code"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Address Type: ({{ order.addressType }})</label
                    >
                    <b-form-select
                      v-model="form.addressType"
                      :options="addressTypesOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Apartment Number: ({{ order.apartmentNumber }})</label
                    >
                    <b-form-input
                      v-model="form.apartmentNumber"
                      type="text"
                      placeholder="please input Apartment Number"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Shipping-Method: ({{ order.deliveryRate }})</label
                    >
                    <b-form-select
                      v-model="form.shippingMethod"
                      :options="shippingMethodsOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Card Type: ({{ order.cardType }})</label
                    >
                    <b-form-select
                      v-model="form.cardType"
                      :options="cardOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div
                v-if="
                  order.cardType &&
                  (order.cardType.includes('Photo') ||
                    form.cardType.includes('Photo'))
                "
                class="row mt-3"
              >
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label">Upload photo: </label>
                    <b-form-file
                      v-model="file"
                      accept=".png, .jpg, .jpeg"
                      class="input-height mt-1"
                      @change="onFileChange"
                    >
                    </b-form-file>

                    <div v-if="photoImage" class="mt-2">
                      <div class="d-flex align-items-center mb-2">
                        <b-button
                          type="button"
                          variant="primary"
                          size="sm"
                          @click="openCropper"
                          class="mr-2"
                        >
                          <i class="fas fa-crop"></i> Crop & Upload
                        </b-button>
                        <b-button
                          type="button"
                          variant="outline-secondary"
                          size="sm"
                          @click="clearPhoto"
                        >
                          <i class="fas fa-times"></i> Clear
                        </b-button>
                      </div>

                      <div class="photo-preview">
                        <b-img
                          :src="photoImage"
                          fluid
                          alt="Photo preview"
                          class="preview-image"
                        ></b-img>
                        <div class="preview-overlay">
                          <small class="text-muted">Click "Crop & Upload" to edit this image</small>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Message Card Image: ({{ order.messageCardImage }})</label
                    >
                    <b-form-input
                      v-model="form.messageCardImage"
                      type="text"
                      placeholder="please input Message Card Image URL"
                      class="input-height mt-1"
                    ></b-form-input>

                    <div v-if="form.messageCardImage" class="mt-2">
                      <div class="uploaded-image-container">
                        <b-img
                          :src="form.messageCardImage"
                          fluid
                          alt="Uploaded photo image"
                          class="uploaded-image"
                        ></b-img>
                        <div class="image-status">
                          <i class="fas fa-check-circle text-success"></i>
                          <small class="text-success ml-1">Image uploaded successfully</small>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <!-- Image Cropper Modal -->
              <ImageCropper
                v-if="photoImage"
                :show="showCropper"
                :image-src="photoImage"
                :order-id="order.orderId"
                @uploading="onUploading"
                @cropped="onImageCropped"
                @error="onCropperError"
                @hidden="showCropper = false"
              />

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >CompleteAfter: ({{ order.completeAfter }})</label
                    >
                    <b-form-input
                      id="completeAfter"
                      v-model="form.completeAfterRaw"
                      type="text"
                      placeholder="e.g. 9am, 9:30am, 14:00"
                      class="input-height mt-1"
                      :state="form.completeAfterRaw ? completeAfterValid : null"
                      @input="parseTimeInput('completeAfter')"
                      @blur="formatTimeInputOnBlur('completeAfter')"
                    ></b-form-input>
                    <b-form-invalid-feedback>Invalid time. Use formats like 9am, 9:30am, or 14:00</b-form-invalid-feedback>
                    <small v-if="form.completeAfter" class="text-muted">Parsed: {{ form.completeAfter }}</small>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >CompleteBefore: ({{ order.completeBefore }})</label
                    >
                    <b-form-input
                      id="completeBefore"
                      v-model="form.completeBeforeRaw"
                      type="text"
                      placeholder="e.g. 6pm, 5:30pm, 18:00"
                      class="input-height mt-1"
                      :state="form.completeBeforeRaw ? completeBeforeValid : null"
                      @input="parseTimeInput('completeBefore')"
                      @blur="formatTimeInputOnBlur('completeBefore')"
                    ></b-form-input>
                    <b-form-invalid-feedback>Invalid time. Use formats like 6pm, 5:30pm, or 18:00</b-form-invalid-feedback>
                    <small v-if="form.completeBefore" class="text-muted">Parsed: {{ form.completeBefore }}</small>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Bouquet Name: ({{ order.bouquetName }})</label
                    >
                    <b-form-select
                      v-model="form.bouquetName"
                      :options="bouquetOpt"
                      @change="selectBouquet"
                      class="input-height mt-1"
                    ></b-form-select>
                    <b-form-input
                      v-model="form.bouquetName"
                      type="text"
                      placeholder="please input Bouquet Name"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Bouquet Size: ({{ order.bouquetSize }})</label
                    >
                    <b-form-select
                      v-model="form.bouquetSize"
                      :options="bouquetSizesOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                    <b-form-input
                      v-model="form.bouquetSize"
                      type="text"
                      placeholder="please input Bouquet Size"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="w-45 col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Addons Inventory:</label>
                    <b-form-select
                      v-model="addons"
                      :options="addonsInventoryOpt"
                      :select-size="6"
                      @dblclick.native="selectAddonAdd"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="w-10">
                  <b-button-group vertical>
                    <label class="mt-1 report-label">Options</label>
                    <br />
                    <b-button
                      type="button"
                      variant="primary"
                      class="button"
                      @click="selectAddonAdd"
                    >
                      &gt;&gt;
                    </b-button>
                    <b-button
                      type="button"
                      variant="primary"
                      class="button"
                      @click="unselectAddonAdd"
                    >
                      &lt;&lt;
                    </b-button>
                  </b-button-group>
                </div>
                <div class="w-45 col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Add Addons:</label>
                    <b-form-select
                      v-model="form.addonsAdd"
                      :options="addonsAddOpt"
                      :select-size="6"
                      @dblclick.native="unselectAddonAdd"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="w-45 col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Order Addons: ({{ order.addons }})</label
                    >
                    <b-form-select
                      v-model="form.addonsOrder"
                      :options="addonsOpt"
                      :select-size="6"
                      @dblclick.native="selectAddonRemove"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="w-10">
                  <b-button-group vertical>
                    <label class="mt-1 report-label">Options</label>
                    <br />
                    <b-button
                      type="button"
                      variant="primary"
                      class="button"
                      @click="selectAddonRemove"
                    >
                      &gt;&gt;
                    </b-button>
                    <b-button
                      type="button"
                      variant="primary"
                      class="button"
                      @click="unselectAddonRemove"
                    >
                      &lt;&lt;
                    </b-button>
                  </b-button-group>
                </div>
                <div class="w-45 col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Remove Addons:</label>
                    <b-form-select
                      v-model="form.addonsRemove"
                      :options="addonsRemoveOpt"
                      :select-size="6"
                      @dblclick.native="unselectAddonRemove"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Add Vase</label>
                    <b-form-select
                      v-model="form.addVase"
                      :options="vaseOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                    <b-form-input
                      v-model="form.addVase"
                      type="text"
                      placeholder="please input Vase"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Remove Vase: ({{ order.vase }})</label
                    >
                    <b-form-select
                      v-model="form.removeVase"
                      :options="removeVaseOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                    <b-form-input
                      v-model="form.removeVase"
                      type="text"
                      placeholder="please input Vase"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Delivery Notes: ({{ order.deliveryNotes }})</label
                    >
                    <b-form-input
                      v-model="form.deliveryNotes"
                      type="text"
                      placeholder="please input Delivery Notes"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Message (Maximum 800 characters)</label
                    >
                    <b-form-textarea
                      v-model="form.message"
                      rows="3"
                      max-rows="8"
                      :state="form.message.length <= 800"
                      placeholder="please input Message"
                    ></b-form-textarea>
                    <label class="mt-1 report-label"
                      >Tips: Properties and timeline tag will be added
                      automatically.</label
                    >
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Send confirmation email</label
                    >
                    <b-form-checkbox
                      v-model="sendConfirmationEmail"
                      value="true"
                      unchecked-value="false"
                    ></b-form-checkbox>
                  </b-form-group>
                </div>
              </div>
              <div v-if="sendConfirmationEmail === 'true'" class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Custom Email</label
                    >
                    <b-form-checkbox
                      v-model="customEmail"
                      value="true"
                      unchecked-value="false"
                    ></b-form-checkbox>
                  </b-form-group>
                  <b-form-group v-if="customEmail === 'true'">
                    <label class="mt-1 report-label"
                      >Canned messages</label
                    >
                    <b-form-select
                      v-model="cannedMessages"
                      :options="cannedMessagesOpt"
                      @change="onCannedMessageSelect"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div v-if="customEmail === 'true'" class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Email Subject</label>
                    <b-form-input
                      v-model="emailSubject"
                      type="text"
                      placeholder="Please input Email Subject"
                      class="input-height mt-1"
                      ref="emailSubject"
                      id="emailSubject"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div v-if="customEmail === 'true'" class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Email Body</label>
                    <b-form-textarea
                      v-model="emailBody"
                      rows="5"
                      max-rows="10"
                      placeholder="Please input Email Body"
                      ref="emailBody"
                      id="emailBody"
                    ></b-form-textarea>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Fields to be removed</label
                    >
                    <b-form-checkbox
                      v-model="buzzerCodeRemoved"
                      value="true"
                      unchecked-value="false"
                      >Buzzer Code</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="apartmentNumberRemoved"
                      value="true"
                      unchecked-value="false"
                      >Apartment Number</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="deliveryNotesRemoved"
                      value="true"
                      unchecked-value="false"
                      >Delivery Notes</b-form-checkbox
                    >
                  </b-form-group>
                </div>
              </div>

              <b-button
                type="button"
                variant="primary"
                class="submit-button"
                @click="generateTimeline"
              >
                Generate
              </b-button>
              &nbsp;&nbsp;&nbsp;
              <b-button
                type="button"
                variant="primary"
                class="submit-button"
                @click="scrollToTop"
              >
                Scroll to top
              </b-button>
            </b-form>
          </div>
        </div>
      </div>
      <div class="page-break"></div>
    </div>
  </b-overlay>
</template>

<script>
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import advancedFormat from "dayjs/plugin/advancedFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import ErrorAlert from "@/components/alerts/error.vue";
import SuccessAlert from "@/components/alerts/success.vue";
import ImageCropper from "@/components/ImageCropper.vue";
import { getAllCities, getCutoffs } from "@/utils/queryUtil";

export default {
  components: {
    ErrorAlert,
    SuccessAlert,
    ImageCropper,
    "v-select": vSelect
  },
  data() {
    return {
      processing: false,
      processingMessage: "Please wait...",
      alertMessage: "",
      activeTab: 0,
      weekChangeInfo: { oldWeek: "", newWeek: "" },
      sendConfirmationEmail: false,
      customEmail: false,
      cannedMessages: "",
      emailSubject: "",
      emailBody: "",
      buzzerCodeRemoved: false,
      apartmentNumberRemoved: false,
      deliveryNotesRemoved: false,
      file: null,
      photoImage: null,
      showCropper: false,
      orderIds: "",
      recordID: "",
      autocomplete: null,
      googleMapsLoaded: false,
      order: {
        orderId: "",
        deliveryDate: "",
        region: "",
        tags: "",
        cname: "",
        phone: "",
        firstName: "",
        lastName: "",
        address: "",
        buzzerCode: "",
        postalCode: "",
        addressType: "",
        apartmentNumber: "",
        city: "",
        province: "",
        shippingMethod: "",
        deliveryNotes: "",
        message: "",
        cardType: "",
        messageCardImage: "",
        bouquetName: "",
        bouquetSize: "",
        addons: null,
        vase: null,
        regionCode: "",
        deliveryRate: ""
      },
      form: {
        cname: "",
        phone: "",
        firstName: "",
        lastName: "",
        address: "",
        buzzerCode: "",
        postalCode: "",
        addressType: "",
        apartmentNumber: "",
        city: "",
        province: "",
        shippingMethod: "",
        deliveryNotes: "",
        message: "",
        cardType: "",
        messageCardImage: "",
        bouquetName: "",
        bouquetSize: "",
        addonsAdd: "",
        addonsRemove: "",
        addVase: "",
        removeVase: "",
        result: "",
        lang: "en-ca",
        completeAfter: "",
        completeBefore: "",
        completeAfterRaw: "",
        completeBeforeRaw: ""
      },
      emptyData: {
        cname: "",
        phone: "",
        firstName: "",
        lastName: "",
        address: "",
        buzzerCode: "",
        postalCode: "",
        addressType: "",
        apartmentNumber: "",
        city: "",
        province: "",
        shippingMethod: "",
        deliveryNotes: "",
        message: "",
        cardType: "",
        messageCardImage: "",
        bouquetName: "",
        bouquetSize: "",
        addonsAdd: "",
        addonsRemove: "",
        addVase: "",
        removeVase: "",
        result: "",
        lang: "en-ca",
        completeAfter: "",
        completeBefore: "",
        completeAfterRaw: "",
        completeBeforeRaw: ""
      },
      addons: "",

      alert: {
        error: false,
        message: ""
      },

      provincesOpt: [],
      citiesOpt: [],

      shippingMethodsOpt: [{ text: "Select an option", value: null }],

      addressTypesOpt: [
        { text: "Select an option", value: null },
        { text: "House", value: "House" },
        { text: "Apartment/Complex", value: "Apartment/Complex" },
        { text: "Business", value: "Business" },
        { text: "Hospital", value: "Hospital" }
      ],

      relationshipsOpt: [
        { text: "Select an option", value: null },
        { text: "Partner", value: "Partner" },
        { text: "Friend", value: "Friend" },
        { text: "Mom", value: "Mom" },
        { text: "Grandparent", value: "Grandparent" },
        { text: "Family member", value: "Family member" },
        { text: "Colleague", value: "Colleague" },
        { text: "Client", value: "Client" },
        { text: "Myself", value: "Myself" },
        { text: "Other", value: "Other" }
      ],

      occasionsOpt: [
        { text: "Select an option", value: null },
        { text: "Birthday", value: "Birthday" },
        { text: "Anniversary", value: "Anniversary" },
        { text: "Celebration", value: "Celebration" },
        { text: "Engagement", value: "Engagement" },
        { text: "Just because", value: "Just because" },
        { text: "Sympathy", value: "Sympathy" },
        { text: "Thinking of you", value: "Thinking of you" },
        { text: "Self-care", value: "Self-care" },
        { text: "Other", value: "Other" }
      ],

      bouquetSizesOpt: [
        { text: "Select an option", value: null },
        { text: "Standard", value: "S" },
        { text: "Deluxe", value: "DX" },
        { text: "Grand", value: "GRD" }
      ],

      cannedMessagesOpt: [
        { text: "Select an option", value: null },
        { text: "Address Adjustment", value: "Address" },
        { text: "Date Adjustment", value: "Date" },
        { text: "Delivery Window Adjustment", value: "DeliveryWindow" }
      ],

      bouquetOpt: [],
      addonsInventoryOpt: [],
      addonsAddOpt: [],
      addonsRemoveOpt: [],
      addonsOpt: [],
      vaseOpt: [],
      cardOpt: [],
      removeAddonsOpt: [],
      removeVaseOpt: [],
      bouquetSizeString: "",
      bouquetSizeObj: {},
      bouquetSizeMap: {
        Standard: "S",
        Deluxe: "DX",
        Grand: "GRD",
        Small: "Small",
        Full: "Full",
        "Full-Size": "Full",
        "Full-Size + Toffee ()": "Full | Utoffeea"
      },
      regionWarehouseMap: {
        Banff_Canmore: "cg",
        Barrie: "tr",
        Barrie_Proper: "tr",
        Calgary: "cg",
        Calgary_Outskirts: "cg",
        Edmonton: "ab",
        Edmonton_Outskirts: "cg",
        Gatineau: "mt",
        Halifax: "hx",
        Hamilton: "tr",
        Hamilton_Outskirts: "tr",
        Kelowna: "bc",
        Kelowna_Surrounding: "bc",
        Kingston: "tr",
        Kitchener_Waterloo: "tr",
        Langley: "bc",
        Lethbridge: "cg",
        London: "tr",
        Maritimes: "hx",
        Maritimes_NB: "hx",
        Maritimes_NS: "hx",
        Maritimes_PEI: "hx",
        Montreal: "mt",
        Northern_AB: "ab",
        Okanagan: "bc",
        Ottawa: "mt",
        Quebec_City: "mt",
        Really_Rural_MB: "mb",
        Regina: "sk",
        Rural_MB: "mb",
        Rural_SK: "sk",
        Saskatoon: "sk",
        Southern_AB: "cg",
        Southern_Ontario: "tr",
        "St_Catharine's_Area": "tr",
        Surrounding_VAC: "bc",
        Toronto: "tr",
        Toronto_Outskirts: "tr",
        Toronto_Restricted: "tr",
        Vancouver: "bc",
        Vancouver_Outskirts: "bc",
        Victoria: "bc",
        Winnipeg: "mb",
        Winnipeg_Outskirts: "mb",
        Winnipeg_Surrounding: "mb"
      },
      consentOpt: [
        { text: "Yes", value: "Yes" },
        { text: "No", value: "No" }
      ],
      langOpt: [
        { text: "CA-EN", value: "en-ca" },
        { text: "CA-FR", value: "fr-ca" }
      ],
      text2EmailLangObj: {
        "ca-en": "en-ca",
        "ca-fr": "fr-ca"
      },
      email2TextLangObj: {
        "en-ca": "ca-en",
        "fr-ca": "ca-fr"
      },
      provinceCityObj: {},
      cityRegionObj: {},
      allCitiesObj: {},
      closedDays: [],
      unavailableDates: [],
      availableDates: [],
      cutoffTime: [],
      queryString: ""
    };
  },
  computed: {
    completeAfterValid() {
      if (!this.form.completeAfterRaw) return null;
      return this.parseTimeString(this.form.completeAfterRaw) !== null;
    },
    completeBeforeValid() {
      if (!this.form.completeBeforeRaw) return null;
      return this.parseTimeString(this.form.completeBeforeRaw) !== null;
    }
  },
  async mounted() {
    this.queryCities();

    // Load Google Maps API and initialize autocomplete
    await this.loadGoogleMapsAPI();
  },
  beforeDestroy() {
    // Clean up Google Maps listeners
    if (this.autocomplete) {
      window.google?.maps?.event?.clearInstanceListeners(this.autocomplete);
    }
  },
  methods: {
    onActivateTab(newIndex, oldIndex) {
      console.log(`From Tab ${oldIndex} to Tab ${newIndex}`);
      console.log(`active tab index: ${this.activeTab}`);
      this.activeTab = newIndex;
    },
    async query1() {
      if (!this.order.orderId) {
        this.displayMessage("warning", `Order Name can't be empty`);
        return false;
      }
      console.log("orderId:", this.order.orderId);
      const orderName = this.order.orderId.replace("#", "");
      await this.query(orderName);
    },
    async query2() {
      if (!this.orderIds) {
        this.displayMessage("warning", `Order Name can't be empty`);
        return false;
      }
      const orderName = this.orderIds
        .replace(/\r\n/g, ",")
        .replace(/\r/g, ",")
        .replace(/\n/g, ",")
        .split(",");
      console.log("orderName:", orderName);
      await this.query(orderName[0].replace("#", ""));
    },
    async query3() {
      if (!this.recordID) {
        this.displayMessage("warning", `Order Name can't be empty`);
        return false;
      }
      const recordID = this.recordID;
      await this.query(recordID);
    },
    async query(queryString) {
      this.processing = true;
      this.displayMessage("Success", "Getting order data...");

      this.form = { ...this.emptyData };
      this.sendConfirmationEmail = false;
      this.customEmail = false;
      this.emailSubject = "";
      this.emailBody = "";
      this.buzzerCodeRemoved = false;
      this.apartmentNumberRemoved = false;
      this.deliveryNotesRemoved = false;
      this.photoImage = null;
      this.file = null;
      this.alertMessage = "";

      try {
        this.form.bouquetName = null;
        const url =
          process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
          "/pull-automation/order/" +
          queryString;
        const response = await this.axios
          .get(url)
          .then(res => {
            console.log("response:", res);
            if (res && res.data) {
              return res.data;
            } else {
              this.displayMessage(
                "warning",
                `Query Exception: Please try again or re-login.`
              );
            }
          })
          .catch(err => {
            this.displayMessage("warning", `Query Exception: ${err}`);
          });
        if (!response) {
          this.processing = false;
          return;
        }
        this.order = response;

        const tags = this.order.tags || "";
        if (tags.includes("pulled") || tags.includes("sent")) {
          this.alertMessage = "This order has been pulled or sent";
          this.displayMessage("warning", `This order has been pulled or sent`);
        }
        const status = this.order.status;
        if (status) {
          if (status === "cancelled") {
            this.alertMessage = "This order has been cancelled";
            this.displayMessage("warning", `This order has been cancelled`);
          } else if (status === "closed") {
            this.alertMessage = "This order has been closed";
            this.displayMessage("warning", `This order has been closed`);
          }
        }
        const fulfillmentStatus = this.order.fulfillmentStatus;
        if (fulfillmentStatus === "fulfilled") {
          this.alertMessage = "This order has been fulfilled";
          this.displayMessage("warning", `This order has been fulfilled`);
        }

        if (this.order.cardType && this.order.cardType.includes("Photo")) {
          const lineItems = this.order.lineItems || [];
          const properties = lineItems.flatMap(
            lineItem => lineItem.properties || []
          );
          this.order.messageCardImage =
            (
              properties.find(
                property => property.name === "Message Card Image"
              ) || {}
            ).value || "";
        }
        if (this.order.province) {
          this.order.province = this.order.province
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        }
        if (this.order.city) {
          this.order.city = this.order.city
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        }
        await this.queryCutoffs();
        //sample Anytime (9am - 6pm)
        if (this.order.deliveryRate) {
          const rateArray = this.order.deliveryRate.split("-");
          const afterPart = rateArray[0]?.split("(")[1];
          const beforePart = rateArray[1]?.split(")")[0];
          this.order.completeAfter = afterPart ? afterPart.trim() : "";
          this.order.completeBefore = beforePart ? beforePart.trim() : "";
        }

        this.order.lang = this.text2EmailLangObj[
          this.order.lang?.toLowerCase()
        ];
        const deliveryDateObj = dayjs.tz(
          this.order.deliveryDate,
          "America/Winnipeg"
        );
        const deliveryDateObjNew = dayjs(this.order.deliveryDate);
        const weekNum = this.extractWeekNumber(deliveryDateObjNew);
        let warehouseCode;
        if (this.order.regionCode) {
          warehouseCode = this.order.regionCode;
        } else {
          warehouseCode = this.regionWarehouseMap[this.order.region];
        }
        const postalCode = this.order.postalCode;
        const lang = this.order.lang;
        const deliveryDate = deliveryDateObj.format("YYYY-MM-DD");

        const currentTimeStamp = dayjs().tz("America/Winnipeg");
        const today = currentTimeStamp.startOf("day");
        if (!deliveryDateObj.isBefore(today)) {
          await this.queryProductsByParams(
            warehouseCode,
            weekNum,
            postalCode,
            deliveryDate,
            lang
          );
        } else {
          this.displayMessage(
            "warning",
            `Order delivery date is before today. Please select a new delivery date`
          );
        }

        this.addonsOpt.length = 0;
        if (this.order.addons) {
          const addons = this.order.addons.split(",");
          for (const addon of addons) {
            let addonStr = addon;
            let addonQuantity = 1;
            if (addon.includes("(")) {
              addonStr = addon.split("(")[0].trim();
              addonQuantity = parseInt(
                addon
                  .split("(")[1]
                  .trim()
                  .replace(/\s|[)]|x/g, "")
              );
            }
            const orderAddonsObj = this.addonsInventoryOpt.find(item => {
              return (
                item.value.value.toLowerCase().trim() ===
                addonStr.toLowerCase().trim()
              );
            });
            if (orderAddonsObj) {
              this.addonsOpt.push({
                text: `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price} (x${addonQuantity})`,
                value: {
                  value: orderAddonsObj.value.value,
                  id: orderAddonsObj.value.id,
                  price: orderAddonsObj.value.price,
                  quantity: addonQuantity,
                  quantityAvailable: orderAddonsObj.value.quantityAvailable
                }
              });
            }
          }
        }
        this.removeVaseOpt.length = 0;
        this.removeVaseOpt.push({ text: "Select an option", value: null });
        if (this.order.vase) {
          this.removeVaseOpt.push({
            text: this.order.vase,
            value: this.order.vase
          });
        }
      } catch (e) {
        console.error("query error:", e);
      }

      this.processing = false;
    },
    async queryCities() {
      const response = await getAllCities();
      if (response) {
        this.allCitiesObj = response;
        for (const key of Object.keys(response)) {
          const provinceName = key;
          const cities = [];
          const province = { text: provinceName, value: provinceName };
          for (const val of response[key]) {
            for (const city of val.cities) {
              cities.push(`${city.name}(${val.shortCode})`);
              this.cityRegionObj[`${city.name}(${val.shortCode})`] =
                val.regionTag;
            }
          }
          this.provincesOpt.push(province);
          this.provinceCityObj[provinceName] = cities.sort((a, b) =>
            a > b ? 1 : -1
          );
        }
        this.provincesOpt = this.provincesOpt.sort((a, b) =>
          a.value > b.value ? 1 : -1
        );
        return true;
      } else {
        this.displayMessage("warning", `queryCities Exception`);
      }
    },
    selectProvince() {
      this.form.city = "";
      this.citiesOpt = this.provinceCityObj[this.form.province];
    },
    async selectCity() {
      this.form.region = "";
      if (this.form.city) {
        this.form.region = this.cityRegionObj[this.form.city];
        await this.queryCutoffs();
        this.form.deliveryDateNew = "";
      }
    },
    async queryCutoffs() {
      const region = this.form.region || this.order.region;
      if (!region) {
        this.displayMessage("warning", `Please select region`);
        return;
      }
      const cutoffs = await getCutoffs(region);
      if (cutoffs) {
        if (cutoffs.closedDates) {
          this.closedDays = cutoffs.closedDates.map(closeD => parseInt(closeD));
        }
        this.form.regionCode = cutoffs.region;
        this.unavailableDates = cutoffs.un_available;
        this.availableDates = cutoffs.available;
        this.cutoffTime = cutoffs.cutoff_time;
        return true;
      } else {
        this.displayMessage("warning", `queryCutoffs Exception`);
      }
    },
    async queryProducts() {
      const postalCode = this.form.postalCode || this.order.postalCode;
      const lang = this.form.lang || this.order.lang;
      const deliveryDate = this.form.deliveryDateNew || this.order.deliveryDate;
      console.log("new delivery date:", this.form.deliveryDateNew);
      const deliveryDateObj = dayjs(deliveryDate);
      const weekNum = this.extractWeekNumber(deliveryDateObj);
      const warehouseCode = this.form.regionCode || this.order.regionCode;
      console.log("lang:", lang);

      await this.queryProductsByParams(
        warehouseCode,
        weekNum,
        postalCode,
        deliveryDate,
        lang
      );
    },
    async queryProductsByParams(
      warehouseCode,
      weekNum,
      postalCode,
      deliveryDate,
      lang
    ) {
      this.bouquetOpt.length = 0;
      this.bouquetOpt.push({ text: "Select an option", value: "" });
      this.bouquetSizeObj = {};
      // this.displayMessage("Success", "Getting bouquets...");
      await this.queryBouquets(warehouseCode, weekNum, "Flowers");
      // this.displayMessage("Success", "Getting Bundle...");
      await this.queryBouquets(warehouseCode, weekNum, "Bundle");
      // this.displayMessage("Success", "Getting Curated_Bundle...");
      await this.queryBouquets(warehouseCode, weekNum, "Curated_Bundle");
      this.displayMessage("Success", "Getting Products...");
      // this.displayMessage("Success", "Getting vases...");
      await this.queryVases(warehouseCode, weekNum);
      // this.displayMessage("Success", "Getting addons...");
      await this.queryAddons(warehouseCode, weekNum);
      // this.displayMessage("Success", "Getting cards...");
      await this.queryCard(warehouseCode, weekNum);

      if (postalCode && lang && deliveryDate && postalCode.length >= 6) {
        // this.displayMessage("Success", "Getting delivery window...");
        await this.queryDeliveryRates(postalCode, deliveryDate, lang);
      }
      // this.displayMessage("Success", "Query Products: Done...");
    },
    async queryDeliveryWindow() {
      const postalCode = this.form.postalCode || this.order.postalCode;
      const lang = this.form.lang || this.order.lang;
      const deliveryDate = this.form.deliveryDateNew || this.order.deliveryDate;
      console.log("postalCode:", postalCode);
      console.log("lang:", lang);
      console.log("deliveryDate:", deliveryDate);

      if (postalCode && lang && deliveryDate && postalCode.length >= 6) {
        await this.queryDeliveryRates(postalCode, deliveryDate, lang);
      }
    },
    async queryBouquets(warehouseCode, weekNum, productType) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const data = {
        queryId: "products_filter",
        productType: productType,
        region: warehouseCode,
        dateCode: weekNum
      };
      const bouquetList = await this.axios
        .post(inventoryUrl, data)
        .then(res => {
          console.log("Inventory response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryBouquets Exception: ${err}`);
        });
      if (bouquetList) {
        const bouquetOpt = [];
        for (const bouquet of bouquetList) {
          if (bouquet.node.availableForSale) {
            bouquetOpt.push({
              text: bouquet.node.title,
              value: bouquet.node.title
            });
            const variantOpt = [];
            variantOpt.push({ text: "Select an option", value: "" });
            for (const variant of bouquet.node.variants.edges) {
              const sizeText = variant.node.title;
              let sizeValue;
              if (sizeText.includes("Full-Size + Toffee")) {
                sizeValue = "DX | Utoffeea";
              } else {
                sizeValue = this.bouquetSizeMap[sizeText.split(" ")[0]];
              }
              if (!sizeValue) {
                sizeValue = sizeText.split(" ")[0];
              }
              variantOpt.push({
                text: `${sizeText} - $${variant.node.price.amount} (${variant.node.quantityAvailable})`,
                value: sizeValue,
                id: variant.node.id,
                sku: variant.node.sku,
                price: variant.node.price?.amount,
                imageSrc: variant.node.image?.transformedSrc
              });
            }
            this.bouquetSizeObj[bouquet.node.title] = variantOpt;
          }
        }
        this.bouquetOpt.push({
          label: productType,
          options: bouquetOpt
        });
      } else {
        console.log("bouquetList is null");
      }
    },
    async queryVases(warehouseCode, weekNum) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const vaseData = {
        queryId: "products_with_product_type_filter",
        productType: "Vase",
        region: warehouseCode,
        dateCode: weekNum
      };
      const vaseList = await this.axios
        .post(inventoryUrl, vaseData)
        .then(res => {
          console.log("query vase response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryVases Exception: ${err}`);
        });
      if (vaseList) {
        this.vaseOpt.length = 0;
        this.vaseOpt.push({ text: "Select an option", value: "" });
        for (const vase of vaseList) {
          if (vase.node.availableForSale) {
            const variant = vase.node.variants.edges[0]?.node;
            if (!variant) continue;
            this.vaseOpt.push({
              text: `${vase.node.title} - $${variant.price.amount} (${variant.quantityAvailable})`,
              value: vase.node.title,
              id: variant.id,
              price: variant.price.amount
            });
          } else {
            console.log(
              "vase is not availableForSale:",
              vase.node.availableForSale
            );
          }
        }
      } else {
        console.error("vaseList is empty:", vaseList);
      }
    },
    async queryAddons(warehouseCode, weekNum) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const addonsData = {
        queryId: "products_filter",
        productType: "Gift-adds",
        region: warehouseCode,
        dateCode: weekNum
      };
      const addonsList = await this.axios
        .post(inventoryUrl, addonsData)
        .then(res => {
          console.log("query addons response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryVases Exception: ${err}`);
        });
      if (addonsList) {
        this.addonsInventoryOpt.length = 0;
        for (const addons of addonsList) {
          const variant = addons.node.variants?.edges[0]?.node;
          if (addons.node.availableForSale && variant && variant.quantityAvailable > 0) {
            this.addonsInventoryOpt.push({
              text: `${addons.node.title} - $${variant.price.amount} (${variant.quantityAvailable})`,
              value: {
                value: addons.node.title,
                id: variant.id,
                price: variant.price.amount,
                quantityAvailable: variant.quantityAvailable
              }
            });
          }
        }
      }
    },
    async queryCard(warehouseCode, weekNum) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const cardData = {
        queryId: "products_with_product_type_filter",
        productType: "Card",
        region: warehouseCode,
        dateCode: weekNum
      };
      const cardList = await this.axios
        .post(inventoryUrl, cardData)
        .then(res => {
          console.log("query card response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryVases Exception: ${err}`);
        });
      if (cardList) {
        this.cardOpt.length = 0;
        this.cardOpt.push({ text: "Select an option", value: "" });
        for (const card of cardList) {
          const tags = card.node.tags;
          if (
            card.node.availableForSale &&
            // !tags.includes("exclusive-card") &&
            (tags.includes(weekNum) || tags.includes("card-ongoing")) &&
            !tags.includes("not-" + weekNum)
          ) {
            const variant = card.node.variants.edges[0]?.node;
            if (!variant) continue;
            this.cardOpt.push({
              text: `${card.node.title} - $${variant.price.amount} (${variant.quantityAvailable})`,
              value: card.node.title,
              id: variant.id,
              price: variant.price.amount,
              quantityAvailable: variant.quantityAvailable
            });
          }
        }
      }
    },
    async queryDeliveryRates(postal, deliveryDate, lang) {
      const postalNew = postal.replace(/\s+/g, "");
      const rateUrl = `https://shop.callia.com/rates/delivery/postalcode/${postalNew}/date/${deliveryDate}?lang=${lang}`;
      const rateList = await this.axios
        .get(rateUrl)
        .then(res => {
          console.log("queryDeliveryRates response:", res.data);
          return JSON.parse(JSON.parse(res.data.body)).sort((a, b) => {
            return (
              Number(a.zone_rate.replace("$", "")) -
              Number(b.zone_rate.replace("$", ""))
            );
          });
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage(
            "warning",
            `queryDeliveryRates Exception: ${err}`
          );
        });
      if (rateList) {
        this.shippingMethodsOpt.length = 0;
        this.shippingMethodsOpt.push({ text: "Select an option", value: "" });
        for (const rate of rateList) {
          if (rate.status === true) {
            this.shippingMethodsOpt.push({
              text: `${rate.display_text} - ${rate.zone_rate.replace(
                ".00",
                ""
              )}`,
              value: rate.display_text.replace(".00", "")
            });
          }
        }
        console.log("shippingMethodsOpt:", this.shippingMethodsOpt);
      }
    },
    selectBouquet() {
      this.form.bouquetSize = "";
      this.bouquetSizesOpt = this.bouquetSizeObj[this.form.bouquetName];
    },
    selectAddonAdd() {
      console.log("addons:", this.addons);
      if (this.addons) {
        const orderAddonsObj = this.addonsAddOpt.find(
          item => item.value.value === this.addons.value
        );
        if (orderAddonsObj) {
          if (orderAddonsObj.value.quantity < this.addons.quantityAvailable) {
            orderAddonsObj.value.quantity++;
            orderAddonsObj.text = `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price}
                                  (x${orderAddonsObj.value.quantity})`;
          }
        } else {
          this.addonsAddOpt.push({
            text: `${this.addons.value} - $${this.addons.price} (x1)`,
            value: {
              value: this.addons.value,
              id: this.addons.id,
              price: this.addons.price,
              quantity: 1,
              quantityAvailable: this.addons.quantityAvailable
            }
          });
        }
      } else {
        this.displayMessage("warning", `Please select Addons to add`);
      }
    },
    unselectAddonAdd() {
      console.log("this.form.addonsAdd:", this.form.addonsAdd);
      if (this.form.addonsAdd) {
        const orderAddonsObj = this.addonsAddOpt.find(
          item => item.value.value === this.form.addonsAdd.value
        );
        if (this.form.addonsAdd.quantity > 1) {
          this.form.addonsAdd.quantity--;
          orderAddonsObj.text = `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price}
                                (x${orderAddonsObj.value.quantity})`;
        } else {
          this.addonsAddOpt = this.addonsAddOpt.filter(
            item => item.value.value !== this.form.addonsAdd.value
          );
        }
      } else {
        this.displayMessage("warning", `Please select Addons to remove`);
      }
    },
    selectAddonRemove() {
      console.log("addons:", this.form.addonsOrder);
      if (this.form.addonsOrder) {
        const orderAddonsObj = this.addonsRemoveOpt.find(
          item => item.value.value === this.form.addonsOrder.value
        );
        console.log("orderAddonsObj:", orderAddonsObj);
        if (orderAddonsObj) {
          if (orderAddonsObj.value.quantity < this.form.addonsOrder.quantity) {
            orderAddonsObj.value.quantity++;
            orderAddonsObj.text = `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price}
                                  (x${orderAddonsObj.value.quantity})`;
          }
        } else {
          this.addonsRemoveOpt.push({
            text: `${this.form.addonsOrder.value} - $${this.form.addonsOrder.price} (x1)`,
            value: {
              value: this.form.addonsOrder.value,
              id: this.form.addonsOrder.id,
              price: this.form.addonsOrder.price,
              quantity: 1,
              quantityAvailable: this.form.addonsOrder.quantityAvailable
            }
          });
        }
      } else {
        this.displayMessage("warning", `Please select Addons to add`);
      }
    },
    unselectAddonRemove() {
      console.log("this.form.addonsRemove:", this.form.addonsRemove);
      if (this.form.addonsRemove) {
        const orderAddonsObj = this.addonsRemoveOpt.find(
          item => item.value.value === this.form.addonsRemove.value
        );
        console.log("orderAddonsObj:", orderAddonsObj);
        if (!orderAddonsObj) {
          this.displayMessage("warning", `Addon not found in remove list`);
          return;
        }
        if (orderAddonsObj.value.quantity > 1) {
          orderAddonsObj.value.quantity--;
          orderAddonsObj.text = `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price}
                                (x${orderAddonsObj.value.quantity})`;
          console.log("orderAddonsObj2:", orderAddonsObj);
        } else {
          this.addonsRemoveOpt = this.addonsRemoveOpt.filter(
            item => item.value.value !== orderAddonsObj.value.value
          );
        }
      } else {
        this.displayMessage("warning", `Please select Addons to remove`);
      }
    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      const dateSelected = dayjs.tz(ymd, "America/Winnipeg");
      const currentTimeStamp = dayjs().tz("America/Winnipeg");
      const today = currentTimeStamp.startOf("day");
      const formatedDate = dateSelected.format("YYYY-MM-DD");
      if (dateSelected.isBefore(today)) {
        return true;
      }
      if (this.availableDates && this.availableDates.length > 0) {
        for (const availableDates of this.availableDates) {
          if (availableDates.date.includes(formatedDate)) {
            const cutOffTimeStamp = dateSelected
              .subtract(parseInt(availableDates.cutoff_effect), "d")
              .startOf("d")
              .add(availableDates.cutoff_time.split(/:|\./)[0], "h")
              .add(availableDates.cutoff_time.split(/:|\./)[1], "m");

            if (cutOffTimeStamp.isAfter(currentTimeStamp)) {
              return false;
            }
          }
        }
      }
      if (this.unavailableDates.includes(formatedDate)) {
        return true;
      }
      if (this.closedDays.includes(weekday)) {
        return true;
      }

      const cutoff = this.cutoffTime.find(df => +df.day === dateSelected.day());
      //Calculate the cutoff time (d - cutoff_effect)
      if (cutoff) {
        const cutOffTimeStamp = dateSelected
          .subtract(parseInt(cutoff.cutoff_effect), "d")
          .startOf("d")
          .add(cutoff.cutoff_time.split(/:|\./)[0], "h")
          .add(cutoff.cutoff_time.split(/:|\./)[1], "m");

        return cutOffTimeStamp.isBefore(currentTimeStamp);
      } else {
        console.log("no cutoff", dateSelected.day());
        return true;
      }
    },
    async onFileChange(e) {
      console.log("onFileChange e.target:", e.target);
      console.log("onFileChange files[0]:", e.target.files[0]);
      const file = e.target.files[0];
      if (file) {
        // Validate file type
        const validTypes = ["image/jpeg", "image/jpg", "image/png"];
        if (!validTypes.includes(file.type)) {
          this.displayMessage("warning", "Please select a valid image file (JPG, JPEG, or PNG)");
          return;
        }

        // Validate file size (max 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
          this.displayMessage("warning", "File size must be less than 10MB");
          return;
        }

        const reader = new FileReader();
        reader.onload = async (readerEvent) => {
          this.photoImage = reader.result;

          // Check image dimensions
          const img = new Image();
          img.onload = () => {
            const minSize = 300; // Minimum size for crop area
            if (img.width < minSize || img.height < minSize) {
              this.displayMessage("warning", `Image is too small for cropping. Minimum size required: ${minSize}x${minSize} pixels. Current size: ${img.width}x${img.height} pixels.`);
              this.photoImage = null;
              this.file = null;
              // Clear the file input
              e.target.value = "";
            }
          };
          img.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },

    openCropper() {
      if (!this.photoImage || this.photoImage.trim() === "") {
        this.displayMessage("warning", "Please select an image first");
        return;
      }
      if (!this.order.orderId) {
        this.displayMessage("warning", "Please query an order first");
        return;
      }
      this.showCropper = true;
    },

    clearPhoto() {
      this.photoImage = null;
      this.file = null;
      this.form.messageCardImage = "";
      // Clear the file input by resetting its value
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }
      });
    },

    onUploading(result) {
      this.displayMessage("warning", result);
    },

    onImageCropped(result) {
      console.log("Image cropped successfully:", result);
      this.form.messageCardImage = result.imageUrl;
      this.displayMessage("Success", "Image cropped and uploaded successfully!");
    },

    onCropperError(error) {
      console.error("Cropper error:", error);
      this.displayMessage("warning", `Image cropping failed: ${error}`);
      // Close the cropper on error
      this.showCropper = false;
    },
    extractWeekNumber(date) {
      let weekNum = date.format("WW");
      // //Check if weekcode around beginning of year needs correction.
      if ((weekNum == "52" || weekNum == "53") && date.month() == 0) {
        weekNum = weekNum + date.subtract(1, "year").format("YY");
      } else if (weekNum == 1 && date.month() == 11) {
        weekNum = weekNum + date.add(1, "year").format("YY");
      } else {
        weekNum = weekNum + date.format("YY");
      }
      return weekNum;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async generateTimeline() {
      // if (!this.order.email) {
      //   this.displayMessage("warning", `Please input Order Name and Query Order`);
      //   return false;
      // }
      const user = this.$store.getters.currentUser;
      if (user) {
        const request = {
          sendConfirmationEmail: this.sendConfirmationEmail
        };
        if (this.sendConfirmationEmail && this.customEmail) {
          if (this.emailSubject.length === 0) {
            this.displayMessage("warning", `Please input email subject`);
            this.$refs["emailSubject"].focus();
            return false;
          }
          if (this.emailBody.length === 0) {
            this.displayMessage("warning", `Please input email body`);
            this.$refs["emailBody"].focus();
            return false;
          }
          request.emailSubject = this.emailSubject;
          request.emailBody = this.emailBody;
        }
        if (this.activeTab === 0) {
          if (!this.order.orderId) {
            this.displayMessage("warning", `Order Name can't be empty`);
            return false;
          }
          this.orderIds = "";
          this.recordID = "";
          request.orderId = this.order.orderId;
        } else if (this.activeTab === 1) {
          if (!this.orderIds) {
            this.displayMessage("warning", `Order Names can't be empty`);
            return false;
          }
          this.order.orderId = "";
          this.recordID = "";
          request.orderIds = this.orderIds;
        } else if (this.activeTab === 2) {
          if (!this.recordID) {
            this.displayMessage("warning", `Record ID can't be empty`);
            return false;
          }
          this.order.orderId = "";
          this.orderIds = "";
          request.recordID = this.recordID;
        }
        if (this.form.phone) {
          const digits = this.form.phone.replace(/\D/g, "");
          if (digits.length < 10) {
            this.displayMessage("warning", `Phone number is incomplete. Please enter a 10-digit phone number.`);
            return false;
          }
        }
        const json = this.generateJson();
        if (
          json.timelines.length === 0 &&
          json.tags.length === 0 &&
          json.inventories.length === 0
        ) {
          this.displayMessage("warning", `Please input at least one property`);
          return false;
        }
        console.log("json:", JSON.stringify(json, null, 2));
        const userEmail = user.email;
        const url =
          process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
          "/pull-automation/timeline";
        request.userEmail = userEmail;
        request.timelines = json.timelines;
        request.tags = json.tags;
        request.inventories = json.inventories;
        // Compute week change info before the request so it's ready for the callback
        let weekChanged = false;
        if (this.form.deliveryDateNew && this.order.deliveryDate) {
          const oldWeek = this.extractWeekNumber(dayjs(this.order.deliveryDate));
          const newWeek = this.extractWeekNumber(dayjs(this.form.deliveryDateNew));
          if (oldWeek !== newWeek) {
            weekChanged = true;
            this.weekChangeInfo = { oldWeek, newWeek };
          }
        }

        this.axios
          .put(url, request)
          .then(res => {
            console.log("generateTimeline response status:", res.status);
            console.log("generateTimeline response:", res.data);
            if (res.status === 200) {
              this.displayMessage(
                "Success",
                "Properties and timeline tag have been added."
              );
              if (weekChanged) {
                this.$bvModal.show("week-change-modal");
              }
            } else {
              this.displayMessage(
                "warning",
                `generateTimeline Exception: ${res.data}`
              );
            }
          })
          .catch(err => {
            console.log("generateTimeline error:", err);
            // this.displayMessage("warning", `generateTimeline Exception: ${err}`);
          });
      } else {
        this.displayMessage("warning", `Please relogin`);
      }
    },
    generateJson() {
      const json = {
        timelines: [],
        inventories: [],
        tags: []
      };
      if (this.form.message) {
        json.timelines.push({ name: "Message", value: this.form.message });
      }
      if (this.form.firstName) {
        json.timelines.push({ name: "First Name", value: this.form.firstName });
      }
      if (this.form.lastName) {
        json.timelines.push({ name: "Last Name", value: this.form.lastName });
      }
      if (this.form.address) {
        json.timelines.push({ name: "Address", value: this.form.address });
      }
      if (this.form.buzzerCode) {
        json.timelines.push({
          name: "Buzzer Code",
          value: this.form.buzzerCode
        });
      }
      if (
        this.form.postalCode &&
        this.form.postalCode !== this.order.postalCode
      ) {
        json.timelines.push({
          name: "Postal Code",
          value: this.form.postalCode
        });
      }
      if (this.form.addressType) {
        json.timelines.push({
          name: "Address Type",
          value: this.form.addressType
        });
      }
      if (this.form.apartmentNumber) {
        json.timelines.push({
          name: "Apartment Number",
          value: this.form.apartmentNumber
        });
      }
      if (this.form.city && this.form.city !== this.order.city) {
        const city = this.form.city.split("(")[0].trim();
        json.timelines.push({ name: "City", value: city });
      }
      if (this.form.province && this.form.province !== this.order.province) {
        json.timelines.push({ name: "Province", value: this.form.province });
      }
      if (this.form.shippingMethod) {
        json.timelines.push({
          name: "Shipping-Method",
          value: this.form.shippingMethod
        });
      }
      if (this.form.consent && this.form.consent !== this.order.consent) {
        json.timelines.push({ name: "_consent", value: this.form.consent });
      }
      if (this.form.completeAfter || this.form.completeBefore) {
        console.log("completeAfter:", this.form.completeAfter);
        let completeAfter;
        let completeBefore;
        let shippingMethod = "Updated Time (";
        if (this.form.completeAfter) {
          completeAfter = this.form.completeAfter;
        } else {
          completeAfter = this.order.completeAfter;
        }
        shippingMethod += completeAfter;
        shippingMethod += " - ";
        if (this.form.completeBefore) {
          completeBefore = this.form.completeBefore;
        } else {
          completeBefore = this.order.completeBefore;
        }
        shippingMethod += completeBefore;
        shippingMethod += ")";
        if (
          this.order.completeAfter !== completeAfter ||
          this.order.completeBefore !== completeBefore
        ) {
          json.timelines.push({
            name: "Shipping-Method",
            value: shippingMethod
          });
        }
        if (completeAfter.includes("pm") && completeBefore.includes("am")) {
          this.displayMessage(
            "warning",
            `CompleteAfter should before CompleteBefore`
          );
        } else if (
          completeAfter.includes("am") &&
          completeBefore.includes("pm")
        ) {
          console.log("CompleteAfter and CompleteBefore OK");
        } else {
          let completeAfterObj;
          if (completeAfter.includes(":")) {
            completeAfterObj = dayjs(completeAfter, "h:mma");
          } else {
            completeAfterObj = dayjs(completeAfter, "ha");
          }
          let completeBeforeObj;
          if (completeBefore.includes(":")) {
            completeBeforeObj = dayjs(completeBefore, "h:mma");
          } else {
            completeBeforeObj = dayjs(completeBefore, "ha");
          }
          if (completeAfterObj.isAfter(completeBeforeObj)) {
            this.displayMessage(
              "warning",
              `CompleteAfter should before CompleteBefore`
            );
          }
        }
      }
      if (this.form.deliveryNotes) {
        json.timelines.push({
          name: "Delivery Notes",
          value: this.form.deliveryNotes
        });
      }
      if (this.form.cardType) {
        json.timelines.push({ name: "Card Type", value: this.form.cardType });
      }
      if (this.form.messageCardImage) {
        json.timelines.push({
          name: "Message Card Image",
          value: this.form.messageCardImage
        });
      }
      if (this.form.bouquetName) {
        let bouquetSize;
        if (this.form.bouquetSize) {
          bouquetSize = this.form.bouquetSize;
        } else {
          bouquetSize = "S";
        }
        json.timelines.push({
          name: "bouquet",
          value: this.form.bouquetName + " - " + bouquetSize
        });
        const bouquetObj = this.bouquetSizesOpt.find(
          item => item.value === this.form.bouquetSize
        );
        if (bouquetObj && bouquetObj.id) {
          const bouquetId = bouquetObj.id.substring(
            bouquetObj.id.lastIndexOf("/") + 1
          );
          json.timelines.push({ name: "bouquet variant id", value: bouquetId });
          json.timelines.push({
            name: "bouquet image",
            value: bouquetObj.imageSrc
          });
          json.inventories.push({
            name: this.form.bouquetName + " - " + bouquetSize,
            type: "bouquet",
            id: bouquetId,
            quantity: 1
          });
          console.log("bouquet variant obj:", bouquetObj);
          console.log("bouquet variant image url:", bouquetObj.imageSrc);
        } else {
          console.warn("Bouquet variant not found in options for size:", this.form.bouquetSize);
        }
      }

      if (this.addonsAddOpt && this.addonsAddOpt.length > 0) {
        const addonsAdd = [];
        for (const addon of this.addonsAddOpt) {
          if (addon && addon.value) {
            const addonStr = `${addon.value.value} (x${addon.value.quantity})`;
            addonsAdd.push(addonStr);
            json.inventories.push({
              name: addon.value.value,
              type: "-",
              id: addon.value.id,
              quantity: addon.value.quantity
            });
          }
        }
        if (addonsAdd.length > 0) {
          json.timelines.push({
            name: "addons added",
            value: addonsAdd.join(",")
          });
        }
      }

      if (this.addonsRemoveOpt && this.addonsRemoveOpt.length > 0) {
        const addonsRemove = [];
        for (const addon of this.addonsRemoveOpt) {
          if (addon && addon.value) {
            const addonStr = `${addon.value.value} (x${addon.value.quantity})`;
            addonsRemove.push(addonStr);
            json.inventories.push({
              name: addon.value.value,
              type: "+",
              id: addon.value.id,
              quantity: addon.value.quantity
            });
          }
        }
        if (addonsRemove.length > 0) {
          json.timelines.push({
            name: "addons removed",
            value: addonsRemove.join(",")
          });
        }
      }
      if (this.form.addVase) {
        json.timelines.push({ name: "vase added", value: this.form.addVase });
      }
      if (this.form.removeVase) {
        json.timelines.push({
          name: "vase removed",
          value: this.form.removeVase
        });
      }

      if (this.buzzerCodeRemoved) {
        json.timelines.push({ name: "Buzzer Code", value: "" });
      }
      if (this.apartmentNumberRemoved) {
        json.timelines.push({ name: "Apartment Number", value: "" });
      }
      if (this.deliveryNotesRemoved) {
        json.timelines.push({ name: "Delivery Notes", value: "" });
      }

      if (this.form.deliveryDateNew) {
        console.log("new delivery date:", this.form.deliveryDateNew);
        console.log("old delivery date:", this.order.deliveryDate);
        const deliveryDateObj = dayjs.tz(
          this.form.deliveryDateNew,
          "America/Winnipeg"
        );
        const deliveryDate = deliveryDateObj.format("MM/DD/YYYY");
        if (deliveryDate !== this.order.deliveryDate) {
          json.tags.push(deliveryDate);
        }
      }
      if (this.form.region) {
        if (this.form.region !== this.order.region) {
          json.tags.push(`Region:${this.form.region}`);
        }
      }
      if (this.form.phone) {
        if (this.form.phone !== this.order.phone) {
          json.tags.push(`Phone:${this.form.phone}`);
        }
      }
      if (this.form.cname) {
        if (this.form.cname !== this.order.cname) {
          json.tags.push(`CName:${this.form.cname}`);
        }
      }

      this.form.result = json;
      return json;
    },
    formatTime(time) {
      const timeObj = dayjs(time, "HH:mm:ss");
      const timeArray = time.split(":");
      if (timeArray[1] === "00") {
        return timeObj.format("ha");
      } else {
        return timeObj.format("h:mma");
      }
    },
    hideError() {
      this.alert.error = false;
    },
    hideSuccess() {
      this.alert.success = false;
    },
    onCannedMessageSelect(value) {
      const senderName = this.order.sender?.first_name || "there";
      const recipientName = this.form.firstName || this.order.firstName || "";
      if (value === "Address") {
        this.customEmail = "true";
        this.emailSubject = "Update: Your Callia Moment!";
        this.emailBody =
          `Hi ${senderName}!\n\nA quick update on your order for ${recipientName}! They reached out to me and asked us to deliver to a new address that works better for them! We'll keep everything else the same. I wanted to keep you in the loop!😊\n\nHave a bloomin' great day!💐\nCaitlin`;
      } else if (value === "Date") {
        this.customEmail = "true";
        this.emailSubject = "Update: Your Callia Moment!";
        this.emailBody =
          `Hi ${senderName}!\n\nA quick update on your order for ${recipientName}! They reached out to me and asked us to deliver on ${this.form.deliveryDateNew || this.order.deliveryDate} instead! We'll keep everything else the same. I wanted to keep you in the loop!😊\n\nHave a bloomin' great day!💐\n\nCaitlin`;
      } else if (value === "DeliveryWindow") {
        this.customEmail = "true";
        this.emailSubject = "Update: Your Callia Moment!";
        const deliveryRate = this.form.shippingMethod || this.order.deliveryRate;
        const match = deliveryRate ? deliveryRate.match(/\(([^)]+)\)/) : null;
        const deliveryWindow = match ? match[1] : "";
        this.emailBody =
          `Hi ${senderName}!\n\nA quick update on your order for ${recipientName}! They reached out to me and asked us to deliver between ${deliveryWindow} instead! We'll keep everything else the same. I wanted to keep you in the loop!😊\n\nHave a bloomin' great day!💐\nCaitlin`;
      }
    },
    formatPhoneNumber() {
      if (!this.form.phone) {
        return;
      }

      // Remove all non-numeric characters
      let cleaned = this.form.phone.replace(/\D/g, "");

      // Limit to 10 digits
      if (cleaned.length > 10) {
        cleaned = cleaned.substring(0, 10);
      }

      // Format as (XXX) XXX-XXXX
      let formatted = "";
      if (cleaned.length > 0) {
        if (cleaned.length <= 3) {
          formatted = `(${cleaned}`;
        } else if (cleaned.length <= 6) {
          formatted = `(${cleaned.substring(0, 3)}) ${cleaned.substring(3)}`;
        } else {
          formatted = `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
        }
      }

      // Update the form value
      this.form.phone = formatted;
    },
    extractPostalCodeFromAddress() {
      if (!this.form.address) {
        return;
      }

      // Canadian postal code pattern: A1A 1A1 or A1A1A1
      const postalCodeRegex = /[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d/g;
      const matches = this.form.address.match(postalCodeRegex);

      if (matches && matches.length > 0) {
        // Get the last match (postal codes are typically at the end of addresses)
        const extractedPostalCode = matches[matches.length - 1]
          .replace(/\s/g, "")
          .toUpperCase();

        // Format as A1A 1A1
        const formattedPostalCode = extractedPostalCode.replace(
          /([A-Z]\d[A-Z])(\d[A-Z]\d)/,
          "$1 $2"
        );

        // Only update if postal code field is empty or different
        if (!this.form.postalCode || this.form.postalCode !== formattedPostalCode) {
          this.form.postalCode = formattedPostalCode;
          console.log("Auto-populated postal code:", formattedPostalCode);
        }
      }
    },
    loadGoogleMapsAPI() {
      return new Promise((resolve, reject) => {
        // Check if already loaded
        if (window.google && window.google.maps && window.google.maps.places) {
          console.log("Google Maps API already loaded");
          this.googleMapsLoaded = true;
          this.$nextTick(() => {
            this.initAutocomplete();
          });
          resolve();
          return;
        }

        // Check if script is already being loaded
        if (this.googleMapsLoaded) {
          resolve();
          return;
        }

        // Get API key from environment variable
        const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

        if (!apiKey) {
          console.warn("Google Maps API key not found in environment variables. Address autocomplete will not be available.");
          resolve(); // Don't reject, just continue without autocomplete
          return;
        }

        // Create script element
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=Function.prototype`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
          console.log("Google Maps API loaded successfully");
          this.googleMapsLoaded = true;
          this.$nextTick(() => {
            this.initAutocomplete();
          });
          resolve();
        };

        script.onerror = (error) => {
          console.error("Failed to load Google Maps API:", error);
          resolve(); // Don't reject, just continue without autocomplete
        };

        document.head.appendChild(script);
      });
    },
    initAutocomplete() {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.error("Google Maps API not loaded");
        return;
      }

      const input = this.$refs.addressInput?.$el;
      if (!input) {
        console.error("Address input not found");
        return;
      }

      // Create autocomplete instance restricted to Canada
      this.autocomplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: "ca" },
        fields: ["address_components", "formatted_address", "geometry"],
        types: ["address"]
      });

      // Listen for place selection
      this.autocomplete.addListener("place_changed", () => {
        this.handlePlaceSelect();
      });

      console.log("Google Maps Autocomplete initialized for Canada");
    },
    async handlePlaceSelect() {
      const place = this.autocomplete.getPlace();

      if (!place || !place.address_components) {
        console.log("No place details available");
        return;
      }

      console.log("Selected place:", place);

      // Extract address components
      let streetNumber = "";
      let route = "";
      let city = "";
      let province = "";
      let provinceLong = "";
      let postalCode = "";
      let country = "";

      for (const component of place.address_components) {
        const types = component.types;

        if (types.includes("street_number")) {
          streetNumber = component.long_name;
        }
        if (types.includes("route")) {
          route = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          province = component.short_name; // e.g., "ON"
          provinceLong = component.long_name; // e.g., "Ontario"
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.short_name;
        }
      }

      // Verify it's a Canadian address
      if (country !== "CA") {
        this.displayMessage("warning", "Please select a Canadian address");
        return;
      }

      console.log("Extracted components:", {
        streetNumber,
        route,
        city,
        province,
        provinceLong,
        postalCode,
        country
      });

      // Build street address
      const streetAddress = `${streetNumber} ${route}`.trim();

      // Update form fields
      this.form.address = streetAddress;

      if (postalCode) {
        // Format postal code as A1A 1A1
        const formattedPostalCode = postalCode
          .replace(/\s/g, "")
          .toUpperCase()
          .replace(/([A-Z]\d[A-Z])(\d[A-Z]\d)/, "$1 $2");
        this.form.postalCode = formattedPostalCode;
        console.log("Set postal code:", formattedPostalCode);
      }

      // Update province if it matches
      if (province || provinceLong) {
        // Try to find province by short name (ON) or long name (Ontario)
        const provinceObj = this.provincesOpt.find(
          p =>
            p.value === province ||
            p.value === provinceLong ||
            p.text === province ||
            p.text === provinceLong
        );

        if (provinceObj) {
          console.log("Found province:", provinceObj);
          this.form.province = provinceObj.value;

          // Trigger province selection to load cities
          this.selectProvince();

          // Wait for cities to load
          await this.$nextTick();
          await new Promise(resolve => setTimeout(resolve, 100));

          if (city) {
            // Try to find matching city in the options
            const normalizedCity = city
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");

            console.log("Looking for city:", normalizedCity);
            console.log("Available cities:", this.citiesOpt);

            // Look for city with region code - try multiple matching strategies
            let cityOption = this.citiesOpt.find(c => {
              const cityName = c.split("(")[0].trim();
              return cityName.toLowerCase() === normalizedCity.toLowerCase();
            });

            // If not found, try without normalization
            if (!cityOption) {
              cityOption = this.citiesOpt.find(c => {
                const cityName = c.split("(")[0].trim();
                return cityName.toLowerCase() === city.toLowerCase();
              });
            }

            // If still not found, try partial match
            if (!cityOption) {
              cityOption = this.citiesOpt.find(c => {
                const cityName = c.split("(")[0].trim().toLowerCase();
                const searchCity = normalizedCity.toLowerCase();
                return cityName.includes(searchCity) || searchCity.includes(cityName);
              });
            }

            if (cityOption) {
              console.log("Found city:", cityOption);
              this.form.city = cityOption;

              // Trigger city selection to load region and other data
              await this.selectCity();

              // Query delivery window if postal code is available
              if (this.form.postalCode && this.form.postalCode.length >= 6) {
                await this.queryDeliveryWindow();
              }
            } else {
              console.warn("City not found in options:", city);
              this.displayMessage(
                "warning",
                `City "${city}" not found in system. Please select manually.`
              );
            }
          }
        } else {
          console.warn("Province not found in options:", province, provinceLong);
          this.displayMessage(
            "warning",
            `Province "${provinceLong || province}" not found. Please select manually.`
          );
        }
      }

      console.log("Auto-populated address fields:", {
        address: streetAddress,
        city: this.form.city,
        province: this.form.province,
        postalCode: this.form.postalCode,
        region: this.form.region
      });

      this.displayMessage("success", "Address auto-populated successfully!");
    },
    displayMessage(messageType, messageBody) {
      this.$bvToast.toast("Empty Body", {
        title: messageBody,
        variant: messageType,
        headerClass: "py-2 px-4",
        bodyClass: "d-none",
        autoHideDelay: 5000,
        solid: true
      });
    },
    /**
     * Parse a user-typed time string into a dayjs object.
     * Accepts: 9am, 9pm, 9:30am, 9:30pm, 14:00, 9:00, 900, 1400
     * Returns a dayjs object (today's date, time set) or null if invalid.
     */
    parseTimeString(raw) {
      if (!raw) return null;
      const s = raw.trim().toLowerCase().replace(/\s+/g, "");

      // Formats to try in order
      const formats = [
        "h:mma",   // 9:30am
        "h:mmA",
        "H:mm",    // 14:00 / 9:00
        "ha",      // 9am
        "hA",
        "Hmm",     // 930 (ambiguous but common shorthand)
        "HHmm",    // 1400
        "h:mm a",
        "H:mm:ss"
      ];

      for (const fmt of formats) {
        const parsed = dayjs(s, fmt, true);
        if (parsed.isValid()) return parsed;
      }

      // Fallback: try native Date parsing with a dummy date prefix
      const attempt = dayjs(`2000-01-01 ${s}`);
      if (attempt.isValid()) return attempt;

      return null;
    },
    parseTimeInput(field) {
      // field is 'completeAfter' or 'completeBefore'
      const rawField = field + "Raw";
      const parsed = this.parseTimeString(this.form[rawField]);
      if (parsed) {
        // Store the formatted value used by generateJson
        const mins = parsed.minute();
        this.form[field] = mins === 0
          ? parsed.format("ha")
          : parsed.format("h:mma");
      } else {
        this.form[field] = "";
      }
    },
    formatTimeInputOnBlur(field) {
      // On blur, if valid, normalise the raw display text to match stored value
      const rawField = field + "Raw";
      const parsed = this.parseTimeString(this.form[rawField]);
      if (parsed) {
        const mins = parsed.minute();
        const formatted = mins === 0
          ? parsed.format("h:mma")
          : parsed.format("h:mma");
        this.form[rawField] = formatted;
        this.form[field] = formatted;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/form.scss";

.card {
  width: 100%;
  border: none;
}

.report-label {
  font-weight: 600;

  .weight {
    font-weight: 400;
  }

  span {
    font-weight: 400;
  }
}

.upper {
  text-transform: case;
}

#checkbox-group,
.custom-select a:hover,
a:active,
a:focus {
  outline: 0;
}

.page-break {
  width: 100%;
  height: 52px;
}

.photo-preview {
  position: relative;
  max-width: 200px;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  overflow: hidden;

  .preview-image {
    max-height: 200px;
    width: 100%;
    object-fit: cover;
  }

  .preview-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 0.5rem;
    text-align: center;
  }
}

.uploaded-image-container {
  position: relative;
  max-width: 200px;

  .uploaded-image {
    max-height: 200px;
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #dee2e6;
  }

  .image-status {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    padding: 0.25rem 0.5rem;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
  }
}

// Google Maps Autocomplete styling
::v-deep .pac-container {
  z-index: 10000 !important;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  font-family: inherit;
  margin-top: 2px;
}

::v-deep .pac-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f5f5f5;
  }
}

::v-deep .pac-item-query {
  font-weight: 600;
  color: #333;
}

::v-deep .pac-matched {
  font-weight: 700;
}

::v-deep .pac-icon {
  margin-right: 8px;
}
</style>
